import { Accordion, Card, Col, Row } from 'react-bootstrap';
import useModule from '../../../../hooks/theory/useModule';
import { useTranslation } from 'react-i18next';
import React, { useEffect } from 'react';
import { ChapterResponse } from '../../../../types/theory/chapter';
import { CustomToggle } from '../../../atoms/CustomToggle/CustomToggle';
import classNames from 'classnames';
import Spinner from '../../../atoms/Spinner/Spinner';
import { Link } from 'react-router-dom';

interface ModuleChaptersProps {
    moduleSlug: string;
    moduleHasStarted: boolean;
}

const ModuleChapters = ({ moduleSlug, moduleHasStarted }: ModuleChaptersProps) => {
    const { loading, userModuleChapters, userLoadModuleChapters, error } = useModule();
    const { t } = useTranslation();

    useEffect(() => {
        if (!loading && !userModuleChapters && !error) {
            userLoadModuleChapters(moduleSlug!!);
        }
    }, [error, loading, userModuleChapters, userLoadModuleChapters, moduleSlug]);

    return (
        <Row>
            <Col>
                <Accordion id='accordion' className='mb-3'>
                    {userModuleChapters && (
                        <Card>
                            <Card.Header className='py-2 bg-primary'>
                                <h4 className='header-title mb-0 text-white fw-bolder'>Capitole - {userModuleChapters.length}</h4>
                            </Card.Header>
                            <Card.Body>
                                {userModuleChapters.map((chapter: ChapterResponse, index: number) => (
                                    <Card key={index}>
                                        <Card.Body className='p-2'>
                                            <Row className='align-items-center mb-2'>
                                                <Col className='col-auto'>
                                                    <div className='avatar-sm'>
                                                        <span className='avatar-title rounded font-18'>{index + 1}</span>
                                                    </div>
                                                </Col>
                                                <Col className='pl-0'>
                                                    <CustomToggle eventKey={chapter.id} containerClass='m-0' linkClass='d-block pt-2 pb-2'>
                                                        <span className='fw-bold font-16'>{chapter.title}</span>
                                                    </CustomToggle>
                                                </Col>
                                                <Col className='col-auto'>
                                                    <div className='chapter-col'>
                                                        <span className={classNames('rounded-circle font-24', chapter.isFinished ? 'chapter-success' : 'chapter-progress')}>
                                                            {chapter.isFinished ? <i className='mdi mdi-check-bold'></i> : <></>}
                                                        </span>
                                                    </div>
                                                </Col>
                                            </Row>
                                            <Accordion.Collapse eventKey={chapter.id}>
                                                <div>
                                                    <Card.Body className='p-0'>
                                                        <Row className='justify-content-between'>
                                                            <Col className='col-auto'>
                                                                <span className='fw-bold font-16'></span>
                                                            </Col>
                                                            <Col className='col-auto mb-1'>
                                                                <Row>
                                                                    <Col>
                                                                        <span className='fw-bold text-uppercase'>{t('module.quiz')}</span>
                                                                    </Col>
                                                                    <Col>
                                                                        <span className='fw-bold text-uppercase'>{t('module.problems')}</span>
                                                                    </Col>
                                                                </Row>
                                                            </Col>
                                                        </Row>
                                                        {chapter.lectures.map((lecture, index: number) => (
                                                            <Row className='justify-content-between mt-2' key={index}>
                                                                <Col className='col-auto'>
                                                                    {lecture.canStart && moduleHasStarted ? (
                                                                        <Link to={`/lectures/${lecture.slug}`}>
                                                                            <span className='fw-bold font-16'>{lecture.title}</span>
                                                                        </Link>
                                                                    ) : (
                                                                        <span className='fw-bold font-16'>{lecture.title}</span>
                                                                    )}
                                                                </Col>
                                                                <Col className='col-auto'>
                                                                    <Row>
                                                                        <Col>
                                                                            <div className='lecture-col me-3'>
                                                                                <span className={classNames('rounded-circle font-24', lecture.quizFinished ? 'chapter-success' : 'chapter-progress')}>
                                                                                    {lecture.quizFinished ? <i className='mdi mdi-check-bold'></i> : <></>}
                                                                                </span>
                                                                            </div>
                                                                        </Col>
                                                                        <Col>
                                                                            <div className='lecture-col ms-3'>
                                                                                <span
                                                                                    className={classNames('rounded-circle font-24', lecture.problemsFinished ? 'chapter-success' : 'chapter-progress')}>
                                                                                    {lecture.problemsFinished ? <i className='mdi mdi-check-bold'></i> : <></>}
                                                                                </span>
                                                                            </div>
                                                                        </Col>
                                                                    </Row>
                                                                </Col>
                                                            </Row>
                                                        ))}
                                                    </Card.Body>
                                                </div>
                                            </Accordion.Collapse>
                                        </Card.Body>
                                    </Card>
                                ))}
                            </Card.Body>
                        </Card>
                    )}
                    {!userModuleChapters && (
                        <Card>
                            <Card.Header className='py-2 bg-primary'>
                                <h4 className='header-title mb-0 text-white fw-bolder'>{t('comment.plural')}</h4>
                            </Card.Header>
                            <Card.Body>
                                <Row className='justify-content-center'>
                                    <Spinner className='m-2' color='primary' size={'sm'} />
                                </Row>
                            </Card.Body>
                        </Card>
                    )}
                </Accordion>
            </Col>
        </Row>
    );
};

export default ModuleChapters;
